export const c_masthead_m_display_stack__content_MinHeight = {
  "name": "--pf-c-masthead--m-display-stack__content--MinHeight",
  "value": "4.375rem",
  "var": "var(--pf-c-masthead--m-display-stack__content--MinHeight)"
};
export default c_masthead_m_display_stack__content_MinHeight;